import React from 'react'
import DSPathDebugTest from '../components/test/DSPathDebugTest'

const DSPathDebugTestPage: React.FC = () => {
  return <DSPathDebugTest />
}

export default DSPathDebugTestPage